import React from 'react';
import Popover from '../Popover';
import _ from 'lodash';
import PropTypes from 'prop-types';
import t from '../i18n/I18n';

export default class SettingsPopover extends React.Component {
	static propTypes = {
		top: PropTypes.number.isRequired,
		right: PropTypes.number.isRequired,
		onClose: PropTypes.func.isRequired
	};

	render() {
		return (
      <Popover top={this.props.top - 20} left={this.props.right - 170} onClose={this.props.onClose}>
        <div style={{ width: '170px', textAlign: 'right', padding: '20px' }}>
          <div style={{ cursor: 'pointer', color: '#7A7A7A', fontSize: '14px', marginBottom: '10px' }}>
            {t('SETTING_ITEM')} #1
					</div>

          <div style={{ cursor: 'pointer', color: '#7A7A7A', fontSize: '14px' }}>
            {t('SETTING_ITEM')} #2
					</div>
				</div>
			</Popover>
		)
	}
}
